export default __webpack_public_path__ + "static/imageKontakt-7128421cf8cd0c00a55d5e9f1babeaaf.png";